import Modal from '@/core/components/modal/Modal'
import welcomeModal from '@/assets/images/welcome_message_purple.png'
import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

interface Props {
  goToUrl: string
}

const WelcomeModal = ({ goToUrl }: Props) => {
  const navigate = useNavigate()

  return (
    <Modal open={true} maxWidth={'800px'} fullWidth>
      <Box
        sx={{
          background: `url(${welcomeModal})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100%',
          p: 4
        }}
      >
        <Box p={4}>
          <Box p="200px 100px 80px">
            <Box
              sx={{
                position: 'relative',
                top: '50%',
                transform: 'translateY(35%)',
                textAlign: 'center'
              }}
            >
              <Typography variant={'h3'} pb={2} sx={{ color: '#fecb3c' }}>
                ¡WEPPA!
              </Typography>
              <Typography variant={'h4'} pb={2} sx={{ color: 'white' }}>
                Ya es tuyo
              </Typography>
              <Button onClick={() => navigate(goToUrl)} variant="contained">
                Comenzar a aprender
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default WelcomeModal
